var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnosisBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3821_2031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.212891,
    width: 49,
    height: 49,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3821_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 39.0046H32.6666V34.9213H16.3333V39.0046ZM16.3333 32.8796H32.6666V28.7963H16.3333V32.8796ZM24.5 25.3254C26.7458 23.2838 28.6684 21.4718 30.2677 19.8895C31.867 18.3072 32.6666 16.6483 32.6666 14.9129C32.6666 13.6879 32.2243 12.6331 31.3395 11.7483C30.4548 10.8636 29.4 10.4213 28.175 10.4213C27.4604 10.4213 26.7713 10.5659 26.1078 10.8551C25.4442 11.1444 24.9083 11.5442 24.5 12.0546C24.0916 11.5442 23.5557 11.1444 22.8921 10.8551C22.2286 10.5659 21.5395 10.4213 20.825 10.4213C19.6 10.4213 18.5451 10.8636 17.6604 11.7483C16.7757 12.6331 16.3333 13.6879 16.3333 14.9129C16.3333 16.6483 17.1074 18.2817 18.6557 19.8129C20.204 21.3442 22.152 23.1817 24.5 25.3254ZM36.75 45.1296H12.25C11.127 45.1296 10.1658 44.7298 9.36611 43.9301C8.56645 43.1305 8.16663 42.1692 8.16663 41.0463V8.3796C8.16663 7.25668 8.56645 6.2954 9.36611 5.49574C10.1658 4.69609 11.127 4.29626 12.25 4.29626H36.75C37.8729 4.29626 38.8342 4.69609 39.6338 5.49574C40.4335 6.2954 40.8333 7.25668 40.8333 8.3796V41.0463C40.8333 42.1692 40.4335 43.1305 39.6338 43.9301C38.8342 44.7298 37.8729 45.1296 36.75 45.1296ZM12.25 41.0463H36.75V8.3796H12.25V41.0463Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosisBlack);
export default __webpack_public_path__ + "static/media/diagnosisBlack.3e028feebbd60f5154d3997137553b3b.svg";
export { ForwardRef as ReactComponent };